import React from 'react';
import cn from 'classnames';

import CurrencySign from 'components/price/CurrencySign.component';

import CN from './PayPopUpPriceLine.module.scss';

const PayPopUpPriceLine = ({ description, value, icon }) => (
  <div data-bem="PayPopUpPriceLine" className={CN.component}>
    <div data-bem="PayPopUpPriceLine__icon" className={CN.container}>
      <div className={CN.iconContainer}>
        <img src={icon} alt={description} className={CN.icon} />
      </div>

      <div data-bem="PayPopUpPriceLine__description" className={CN.text}>
        {description}:
      </div>
    </div>

    <div
      data-bem="PayPopUpPriceLine__value"
      className={cn({
        [CN.priceFocused]: value > 0,
      })}
    >
      <CurrencySign value={value} />
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default PayPopUpPriceLine;
